// Server caps page size for account-manager getAccountList (a larger value is
// rejected with "invalid page size"). Page through with this to cover all accounts.
export const ACCOUNT_PAGE_SIZE = 50;

/** Premium seats come out of the CFD pool; futures platforms have their own seat tier. */
export const PREMIUM_CFD_ONLY_MESSAGE = 'Premium is only available for CFD accounts';
